mutation DELETE_LOT ($id: UUID!) {
  deleteLot(id: $id) {
    success
    error
  }
}
